import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { HeaderCharmType } from 'owa-header-store';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { HeaderPaneProps } from 'owa-header-pane';

export interface DiagnosticsCharmProps {
    DiagnosticsPanel: React.ComponentType<HeaderPaneProps>;
}

const DiagnosticsCharm = observer(function DiagnosticsCharm(props: DiagnosticsCharmProps) {
    return (
        <HeaderCharm
            key="diagnostic charm"
            icons={{ iconName: ControlIcons.DeveloperTools }}
            ariaLabel="diagnostics charm" // No need to localize as it is a DEV feature only
            title="Diagnostics charm"
            behavior={{
                paneComponent: props.DiagnosticsPanel,
                charm: HeaderCharmType.DiagnosticsCharm,
            }}
        />
    );
});
export default DiagnosticsCharm;
